import { createAction, props } from '@ngrx/store';
import { TheoricalLayer } from '../../models/theorical-layer';

export const loadTheoricalLayers = createAction('[TheoricalLayer/API] Load TheoricalLayers ', props<{ organizationId: string, siteId: string }>());
export const loadTheoricalLayersSuccess = createAction('[TheoricalLayer/API] Load TheoricalLayers success', props<{ theoricalLayers: TheoricalLayer[] }>());
export const loadTheoricalLayersFailure = createAction('[TheoricalLayer/API] Load TheoricalLayers failure', props<{ error: any }>());

export const clearAllTheoricalLayers = createAction('[TheoricalLayer] Clear All TheoricalLayer');
export const selectTheoricalLayer = createAction('[TheoricalLayer] Select Reference TheoricalLayer', props<{ id: string | undefined}>());
